export class PetBreed {
  /** (Integer): Código del tipo de mascota. */
  petTypeCode: number

  /** (Integer): Código de la mascota. */
  breedCode: number

  /** (string): Descripción del tipo de mascota. */
  petTypeDescription: string

  /** (string): Descripción de la raza. */
  breedDescription: string

  constructor(data: any = {}) {
    this.petTypeCode = data.petTypeCode
    this.breedCode = data.breedCode
    this.petTypeDescription = data.petTypeDescription
    this.breedDescription = data.breedDescription
  }
}
